<template>
    <v-dialog
        persistent
        width   = "500"
        v-model = "show"
        v-if    = "message"
    >
        <v-card>
            <v-card-title class="message-title" v-html="$t(message.id + '.title', message.parameter)" v-if="message.id.title">
            </v-card-title>

            <v-card-subtitle class="message-subtitle primary--text">
                Hinweis:
            </v-card-subtitle>
            <v-card-text class="message-text" v-html="$t(message.id + '.message', message.parameter)">
            </v-card-text>

            <v-card-actions>
                <v-spacer  />

                <v-btn
                    v-if="message.action"
                    color="primary"
                    @click="onCase"
                    text
                >
                    {{ $t(message.id + ".action") }}
                </v-btn>

                <v-btn
                    text
                    color="primary"
                    @click="onCancel"
                >
                    Schließen
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import Inc from "@/modules/inc/service/Inc.js";

export default {
    name: "DAppMessage",

    props: {
        value: {

        },
        message: {
            required: false,
            type    : Object,
            default : function () {
                return {
                    id        : "",
                    paramenter: [],
                    actions   : [],
                }
            }
        }
    },

    data: () => ({
        show: false
    }),

    watch: {
        value () {
            this.show = this.value;
        }
    },

    mounted() {
        this.show = this.value;
    },

    methods: {
        onCancel () {
            this.emit();
        },

        onCase () {
            this.emit();
            Inc.goto(this, this.message.action.parameter[0]);
        },

        emit () {
            this.show = false;
            this.$emit("input", this.show);
        }
    }
}
</script>

<style scoped>

.message-title {
    font-size: 1.0rem!important;
    font-weight: 400;
    letter-spacing: normal!important;
}

.message-subtitle {
    font-size: 15px;
    padding-top: 15px!important;
    font-weight: 600;
    padding-bottom: 0!important;
}

.message-text {
    font-size: 16px;
    padding-bottom: 15px!important;
}

</style>